<div class="relative">
  <!-- Title section -->
  @if (title()) {
    <div class="flex justify-between items-center mb-4">
      <div class="flex items-center text-xl leading-none font-semibold tracking-tight">
        {{ title() }}
      </div>
      <div class="flex justify-end">
        <button (click)="toggleEditing()" mat-button class="tertiary">
          <mat-icon [matTooltip]="showEditingState() ? 'Annuler' : 'Modifier'">
            {{ showEditingState() ? 'close' : 'edit' }}
          </mat-icon>
        </button>
      </div>
    </div>
  }

  <!-- No title: button floats top-right -->
  @if (!title()) {
    <button (click)="toggleEditing()" mat-button class="tertiary absolute top-0 right-0 m-2">
      <mat-icon [matTooltip]="showEditingState() ? 'Annuler' : 'Modifier'">
        {{ showEditingState() ? 'close' : 'edit' }}
      </mat-icon>
    </button>
  }

  <!-- Form projection -->
  <ng-content></ng-content>
</div>

@if (showEditingState()) {
  <!-- Save button -->
  <div class="flex justify-end mt-4">
    <button [disabled]="!isValid() || !isChanged()" class="primary" (click)="save()" mat-flat-button>
      <span>Enregistrer</span>
    </button>
  </div>
}
@if (showDivider()) {
  <mat-divider class="my-4"></mat-divider>
}
